import elementBase from "../elementBase.js";

export default class DynamicProgress extends elementBase {
    objectType = "DynamicProgress";
    Foreground = '';
    Background = '';
    BorderColor = '';
    BorderSize = 0;
    SmoothTime = 0;
    styleColor = '#553c9a';

    constructor(args = {}) {
        super(args);
        this.objectToClassValue(args);
    }
    objectToClassValue(args = {}) {
        super.objectToClassValue(args);
        this.Foreground = args.foreground != null ? args.foreground : '#553c9a';
        this.Background = args.background != null ? args.background : '#553c9a';
        this.BorderColor = args.borderColor != null ? args.borderColor : '#553c9a';
        this.BorderSize = args.borderSize != null ? args.borderSize : 0;
        this.SmoothTime = args.smoothTime != null ? args.smoothTime : 0;
    }
    static get Name() {
        return "Progression";
    }
    get changeableProperty() {
        const parentProperty = super.changeableProperty;
        return [
            ...parentProperty.filter(el => el.type != "objectInput" && el.type != "arrayInput"),
            { name: "Foreground", type: "colorInput", dataType: "string" },
            { name: "Background", type: "colorInput", dataType: "string" },
            { name: "BorderColor", type: "colorInput", dataType: "string" },
            { name: "BorderSize", type: "numberInput", dataType: "number" },
            { name: "SmoothTime", type: "numberInput", dataType: "number" },
            ...parentProperty.filter(el => el.type == "objectInput" || el.type == "arrayInput")
        ];
    }
    getStyle(currentElementIndex = null) {
        let style = {
            ...super.getStyle(currentElementIndex),
            backgroundColor: this.Background,
            borderColor: this.BorderColor,
            borderWidth: this.BorderSize,
            position: 'absolute',
        }
        return style;
    }
    toExportObject(variableArray = [], ressourceArray = []) {
        return {
            ...super.toExportObject(variableArray, ressourceArray),
            foreground: this.hexColorValue(this.Foreground),
            background: this.hexColorValue(this.Background),
            borderColor: this.hexColorValue(this.BorderColor),
            borderSize: this.BorderSize,
            smoothTime: this.SmoothTime,
        };
    }
    toObject(minify = false) {
        let object = {
            ...super.toObject(minify),
            foreground: this.Foreground,
            background: this.Background,
            borderColor: this.BorderColor,
            borderSize: this.BorderSize,
            smoothTime: this.SmoothTime,
        };
        return object;
    }
}
